import router from '@/router/index.js';
import axios from '@/util/axios.js';
import api from '@/util/api.js';
import _ from 'lodash'

const default_state = {

};
const state = {

};
const mutations = {
  resetState(){
    
  }
};

const actions = {
  getPayHash(context,data){
    return new Promise((resolve,reject) => {
      axios.post(api.supplier.data_dict_list,data).then(res => {
        if(res.code == 0){
          resolve(res.result.list)
        }else{
          reject(res.msg)
        }
      })
    })
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
